import { useEffect, useState } from "react";

const EMAILS = [
  "ken@bell.labs",
  "guido@python.nl",
  "james@java-lang.ca",
  "bjarne@cplusplus.com",
  "ada@lovelace.co.uk",
  "matz@ruby-lang.jp",
  "brian@bell.labs",
  "chris@swift-lang.com",
  "grace@bugfree.com",
];

export default function useFunnyEmailPlaceholder() {
  const [emailPlaceholder, setEmailPlaceholder] = useState("");

  useEffect(() => {
    setEmailPlaceholder(EMAILS[Math.floor(Math.random() * EMAILS.length)]);
  }, []);

  return [emailPlaceholder];
}
